export const PAGE_NAME = {
  HOME: 'Home',
  ARTIST: 'Artist',
  ARTIST_ADD: 'ArtistAdd',

  LOGIN: 'Login',
  LOGOUT: 'Logout',
  JOIN: 'Join',
  JOIN_SUCCESS: 'JoinSuccess',
  CHANGE_PASSWORD: 'ChangePassword',
} as const
